import { useTranslation } from 'react-i18next';
import type { ReactNode } from 'react';
import { Box, type BoxProps } from '@/components/common';

type ProfilePhotoProps = BoxProps & {
  src: string | undefined;
  name: string;
  index: number;
  overlay?: ReactNode;
};

/** Full-bleed profile photo slot — renders nothing when `src` is missing. */
export function ProfilePhoto({
  src,
  name,
  index,
  overlay,
  style: customStyle = {},
  ...props
}: ProfilePhotoProps) {
  const { t } = useTranslation('profile');

  if (!src) return null;

  return (
    <Box
      width="100%"
      flexShrink="0"
      overflow="hidden"
      position="relative"
      style={{ aspectRatio: 'var(--picture-aspect-ratio)', ...customStyle }}
      {...props}
    >
      <img
        src={src}
        loading="lazy"
        alt={t('view.photoAlt', { name, index })}
        draggable={false}
        referrerPolicy="no-referrer"
        style={{ width: '100%', height: '100%', objectFit: 'cover', pointerEvents: 'none' }}
      />
      {overlay}
    </Box>
  );
}
